import { useState } from "react";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

const apiUrl = process.env.REACT_APP_API_URL;

interface Account {
  name: string;
  email: string;
  account_number: string;
  type_of_account: string;
  code_bank: string;
  // agrega otros campos como `id` si aplica
}

interface CreateAccountResponse {
  message: string;
  data: Account;
  success: boolean;
}

const usePostDeleteAccountBank = () => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const [data, setData] = useState<any | null | any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const deleteAccountBank = async (token: any, body: any) => {
    setLoading(true);
    setError(null);
    setData(null);

    try {
      const tk = await getAccessTokenSilently();

      const response = await axios.post<any>(
        `${apiUrl}/api/v1/accounts/delete`,
        body,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tk}`,
          },
        }
      );

      setData(response?.data);
      return response.data;
    } catch (err: any) {
      setError(err.message || "Error delete account");
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, deleteAccountBank };
};

export default usePostDeleteAccountBank;
